import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

// ANX-087 — staff-сессия продуктовой админки. Полностью отдельна от
// операторской authStore: свой ключ localStorage, свой токен (audience=staff).
export interface StaffUser {
  id: string;
  email: string;
  name: string;
}

export interface StaffSession {
  access: string;
  refresh: string;
  staff: StaffUser;
}

interface StaffAuthState {
  session: StaffSession | null;
  setSession: (s: StaffSession) => void;
  clear: () => void;
}

export const STAFF_AUTH_STORAGE_KEY = 'anexica.staff.v1';

export const useStaffAuthStore = create<StaffAuthState>()(
  persist(
    (set) => ({
      session: null,
      setSession: (session) => set({ session }),
      clear: () => set({ session: null }),
    }),
    {
      name: STAFF_AUTH_STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
